<section class="na-wrap" role="region" aria-labelledby="na-title">
  <h1 id="na-title" class="na-title">{{ title }}</h1>

  <p class="na-message">{{ message }}</p>

  <p class="na-help">
    {{ help }}
    @if (supportHref) {
    <a class="na-link" [href]="supportHref" rel="noopener noreferrer">{{
      supportText
    }}</a>
    }
  </p>

  <div class="na-actions">
    <up-button button-style="contained" (click)="gotoHome()">
      <button type="submit">{{ 'I18N_LABEL.GO_TO_HOME' | translate }}</button>
    </up-button>
  </div>
</section>
